// // import React, { useState } from "react";
// // import { Button, Flex, Form, Grid, message, Spin, theme } from "antd";
// // import { SyncOutlined } from "@ant-design/icons";
// // import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
// // import Cookies from "js-cookie";
// // import { logInOtp } from "../Service/loginOtp";

// // const { useToken } = theme;
// // const { useBreakpoint } = Grid;

// // export default function LoginOtp() {
// //   const { email } = useParams();
// //   const navigate = useNavigate();
// //   const { token } = useToken();
// //   const screens = useBreakpoint();
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   // 👇 OTP state and handler
// //   const [otp, setOtp] = useState(Array(6).fill(""));

// //   const handleOtpChange = (index, value) => {
// //     if (!/^[0-9]?$/.test(value)) return; // allow only numbers
// //     const newOtp = [...otp];
// //     newOtp[index] = value;
// //     setOtp(newOtp);

// //     // auto-focus next box if input entered
// //     if (value && index < 5) {
// //       const nextInput = document.getElementById(`otp-slot-${index + 1}`);
// //       nextInput?.focus();
// //     }
// //   };

// //   const onFinish = () => {
// //     const otpValue = otp.join("");
// //     if (otpValue.length !== 6) {
// //       messageApi.open({
// //         type: "error",
// //         content: "Please enter the full 6-digit OTP!",
// //       });
// //       return;
// //     }

// //     setIsLoading(true);
// //     logInOtp({
// //       otp: otpValue,
// //       email: email,
// //       type: "VERIFICATION",
// //     })
// //       .then((res) => {
// //         const expirationTime = new Date(new Date().getTime() + 10 * 60 * 1000);
// //         Cookies.set("user_details", JSON.stringify(res.data), {
// //           expires: expirationTime,
// //         });
// //         navigate("/", { replace: true });
// //       })
// //       .catch((err) => {
// //         const msg = err.response?.data?.message || err.message;
// //         messageApi.open({
// //           type: "error",
// //           content: msg,
// //         });
// //       })
// //       .finally(() => {
// //         setIsLoading(false);
// //       });
// //   };

// //   const styles = {
// //     container: {
// //       backgroundColor: "rgba(255, 255, 255, 0.2)",
// //       borderRadius: "10px",
// //       backdropFilter: "blur(28px)",
// //       padding: screens.md
// //         ? `${token.paddingXL}px`
// //         : `${token.sizeXXL}px ${token.padding}px`,
// //       width: "350px",
// //     },
// //     footer: {
// //       marginTop: token.marginLG,
// //       textAlign: "center",
// //       width: "100%",
// //     },
// //     forgotPassword: {
// //       paddingTop: "10px",
// //       color: "#d3d5dfff",
// //     },
// //     section: {
// //       backgroundColor: token.colorBgContainer,
// //       display: "flex",
// //       flexDirection: "column",
// //       justifyContent: "center",
// //       alignItems: "flex-end",
// //       minHeight: "100vh",
// //       backgroundPosition: "center",
// //       backgroundSize: "cover",
// //       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
// //       width: "100%",
// //     },
// //     otpContainer: {
// //       display: "flex",
// //       justifyContent: "center",
// //       gap: "8px",
// //       marginTop: "10px",
// //       marginBottom: "20px",
// //     },
// //     otpBox: {
// //       width: "40px",
// //       height: "45px",
// //       textAlign: "center",
// //       fontSize: "20px",
// //       border: "1px solid #ccc",
// //       borderRadius: "8px",
// //       outline: "none",
// //       transition: "border-color 0.2s",
// //     },
// //   };

// //   const useDetails = Cookies.get("user_details");

// //   return useDetails ? (
// //     <Navigate to="/configuration" replace={true} />
// //   ) : (
// //     <>
// //       <section
// //         style={{
// //           ...styles.section,
// //           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
// //         }}
// //       >
// //         {contextHolder}
// //         <div style={styles.container}>
// //           <div
// //             style={{
// //               textAlign: "center",
// //               paddingBottom: "1rem",
// //               display: "flex",
// //               width: "100%",
// //               justifyContent: "center",
// //               color: "white",
// //             }}
// //           >
// //             <img
// //               src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
// //               alt="Logo"
// //               style={{
// //                 width: "2rem",
// //                 height: "auto",
// //                 borderRadius: "50%",
// //                 marginRight: "10px",
// //               }}
// //             />
// //             <h2>Step to Innovation</h2>
// //           </div>

// //           <Form name="otp_login" onFinish={onFinish} layout="vertical">
// //             <Form.Item
// //               label={
// //                 <span style={{ color: "#d3d5dfff", fontWeight: "600" }}>
// //                   One-Time Password
// //                 </span>
// //               }
// //               required
// //             >
// //               {/* 👇 Custom inline OTP input boxes */}
// //               <div style={styles.otpContainer}>
// //                 {otp.map((digit, index) => (
// //                   <input
// //                     key={index}
// //                     id={`otp-slot-${index}`}
// //                     type="text"
// //                     maxLength="1"
// //                     value={digit}
// //                     style={styles.otpBox}
// //                     onChange={(e) => handleOtpChange(index, e.target.value)}
// //                     onFocus={(e) => e.target.select()}
// //                   />
// //                 ))}
// //               </div>
// //             </Form.Item>

// //             <Form.Item style={{ marginBottom: "0px" }}>
// //               <Button
// //                 block
// //                 type="primary"
// //                 htmlType="submit"
// //                 style={{
// //                   padding: "20px 12px",
// //                   backgroundColor: isLoading ? "#1677ff" : undefined,
// //                   borderColor: isLoading ? "#1677ff" : undefined,
// //                   cursor: isLoading ? "not-allowed" : undefined,
// //                 }}
// //                 disabled={isLoading}
// //                 icon={
// //                   <Spin
// //                     spinning={isLoading}
// //                     indicator={<SyncOutlined spin />}
// //                     style={{ color: "white" }}
// //                   />
// //                 }
// //               >
// //                 {!isLoading ? "Submit" : ""}
// //               </Button>
// //             </Form.Item>

// //             <Flex justify="space-between">
// //               <Link to="/login" style={styles.forgotPassword}>
// //                 Back to Login?
// //               </Link>
// //               <Link to="/forget-password" style={styles.forgotPassword}>
// //                 Forgot password?
// //               </Link>
// //             </Flex>
// //           </Form>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }
// import React, { useState } from "react";
// import { Button, Flex, Form, Grid, message, Spin, theme } from "antd";
// import { SyncOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logInOtp } from "../Service/loginOtp";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function LoginOtp() {
//   const { email } = useParams();
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();

//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   /* OTP STATE */
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);

//   /* OTP INPUT CHANGE */
//   const handleOtpChange = (index, value) => {
//     if (!/^\d?$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     if (value && index < 5) {
//       document.getElementById(`otp-${index + 1}`)?.focus();
//     }
//   };

//   /* BACKSPACE HANDLING */
//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       document.getElementById(`otp-${index - 1}`)?.focus();
//     }
//   };

//   /* COPY–PASTE HANDLING */
//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pasted = e.clipboardData.getData("text").trim();
//     if (/^\d{6}$/.test(pasted)) {
//       const newOtp = pasted.split("");
//       setOtp(newOtp);
//       document.getElementById("otp-5")?.focus();
//     }
//   };

//   /* SUBMIT */
//   const onFinish = () => {
//     const otpValue = otp.join("");
//     if (otpValue.length !== 6) {
//       messageApi.open({
//         type: "error",
//         content: "Please enter the full 6-digit OTP",
//       });
//       return;
//     }

//     setIsLoading(true);
//     logInOtp({
//       otp: otpValue,
//       email,
//       type: "VERIFICATION",
//     })
//       .then((res) => {
//         const expirationTime = new Date(Date.now() + 10 * 60 * 1000);
//         Cookies.set("user_details", JSON.stringify(res.data), {
//           expires: expirationTime,
//         });
//         navigate("/", { replace: true });
//       })
//       .catch((err) => {
//         messageApi.open({
//           type: "error",
//           content: err.response?.data?.message || err.message,
//         });
//         setOtp(["", "", "", "", "", ""]);
//         document.getElementById("otp-0")?.focus();
//       })
//       .finally(() => setIsLoading(false));
//   };

//   const userDetails = Cookies.get("user_details");

//   /* 🔹 SAME STYLE SYSTEM AS OTHER AUTH PAGES */
//   const styles = {
//     section: {
//       minHeight: "100vh",x
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "flex-end",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     },

//     container: {
//       background: "#ffffff",
//       borderRadius: "12px",
//       boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
//       padding: "40px",
//       width: "420px",
//     },

//     header: {
//       textAlign: "center",
//       marginBottom: "32px",
//     },

//     subtitle: {
//       fontSize: "14px",
//       color: "#718096",
//     },

//     otpContainer: {
//       display: "flex",
//       justifyContent: "center",
//       gap: "10px",
//       marginTop: "12px",
//       marginBottom: "24px",
//     },

//     otpBox: {
//       width: "44px",
//       height: "48px",
//       textAlign: "center",
//       fontSize: "20px",
//       border: "1px solid #d9d9d9",
//       borderRadius: "8px",
//       outline: "none",
//       transition: "border-color 0.2s",
//     },

//     button: {
//       height: "48px",
//       fontSize: "16px",
//       fontWeight: 600,
//       borderRadius: "8px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       border: "none",
//     },

//     link: {
//       color: "#667eea",
//       fontSize: "14px",
//       fontWeight: 500,
//     },
//   };

//   return userDetails ? (
//     <Navigate to="/configuration" replace />
//   ) : (
//     <>
//       {contextHolder}
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         <div style={styles.container}>
//           {/* HEADER */}
//           <div style={styles.header}>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                 alt="Logo"
//                 style={{
//                   width: "5rem",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                 }}
//               />
//               <h2>Step to Innovation</h2>
//             </div>
//             <p style={styles.subtitle}>
//               Enter the 6-digit OTP sent to <b>{email}</b>
//             </p>
//           </div>

//           {/* FORM */}
//           <Form onFinish={onFinish}>
//             <div style={styles.otpContainer}>
//               {otp.map((digit, index) => (
//                 <input
//                   key={index}
//                   id={`otp-${index}`}
//                   type="text"
//                   maxLength={1}
//                   value={digit}
//                   style={styles.otpBox}
//                   onChange={(e) => handleOtpChange(index, e.target.value)}
//                   onKeyDown={(e) => handleKeyDown(index, e)}
//                   onPaste={handlePaste}
//                   autoFocus={index === 0}
//                 />
//               ))}
//             </div>

//             <Button
//               block
//               type="primary"
//               htmlType="submit"
//               style={styles.button}
//               disabled={isLoading}
//               icon={
//                 isLoading ? (
//                   <Spin
//                     indicator={<SyncOutlined spin />}
//                     style={{ color: "white" }}
//                   />
//                 ) : null
//               }
//             >
//               {!isLoading && "Verify OTP"}
//             </Button>

//             <Flex justify="space-between" style={{ marginTop: "16px" }}>
//               <Link to="/login" style={styles.link}>
//                 Back to Login
//               </Link>
//               <Link to="/forget-password" style={styles.link}>
//                 Forgot password?
//               </Link>
//             </Flex>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }
import React, { useRef, useState } from "react";
import { Button, Flex, Form, Grid, message, Spin, theme } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { logInOtp } from "../Service/loginOtp";

const { useToken } = theme;
const { useBreakpoint } = Grid;

export default function LoginOtp() {
  const { email } = useParams();
  const navigate = useNavigate();
  const { token } = useToken();
  const screens = useBreakpoint();

  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  /* 🔹 OTP STATE */
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);

  /* 🔹 HANDLE OTP CHANGE */
  const handleOtpChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  /* 🔹 BACKSPACE LOGIC */
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  /* 🔹 PASTE FULL OTP */
  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData("text").trim();
    if (!/^\d{6}$/.test(pastedData)) return;

    const pastedOtp = pastedData.split("");
    setOtp(pastedOtp);

    pastedOtp.forEach((digit, index) => {
      if (inputRefs.current[index]) {
        inputRefs.current[index].value = digit;
      }
    });

    inputRefs.current[5]?.focus();
    e.preventDefault();
  };

  /* 🔹 SUBMIT */
  const onFinish = () => {
    const otpValue = otp.join("");
    if (otpValue.length !== 6) {
      messageApi.open({
        type: "error",
        content: "Please enter the full 6-digit OTP!",
      });
      return;
    }

    setIsLoading(true);
    logInOtp({
      otp: otpValue,
      email,
      type: "VERIFICATION",
    })
      .then((res) => {
        const expirationTime = new Date(Date.now() + 10 * 60 * 1000);
        Cookies.set("user_details", JSON.stringify(res.data), {
          expires: expirationTime,
        });
        navigate("/", { replace: true });
      })
      .catch((err) => {
        messageApi.open({
          type: "error",
          content: err.response?.data?.message || err.message,
        });
      })
      .finally(() => setIsLoading(false));
  };

  /* 🔹 STYLES (MATCH LOGIN UI) */
  const styles = {
    section: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-end",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
    },

    container: {
      background: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
      padding: "40px",
      width: "420px",
    },

    header: {
      textAlign: "center",
      marginBottom: "24px",
    },

    subtitle: {
      fontSize: "14px",
      color: "#718096",
    },

    otpContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
      margin: "20px 0",
    },

    otpBox: {
      width: "48px",
      height: "52px",
      textAlign: "center",
      fontSize: "20px",
      borderRadius: "8px",
      border: "1px solid #d9d9d9",
      outline: "none",
      transition: "all 0.2s",
    },

    button: {
      height: "48px",
      fontSize: "16px",
      fontWeight: 600,
      borderRadius: "8px",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      border: "none",
    },

    link: {
      color: "#667eea",
      fontSize: "14px",
      fontWeight: 500,
    },
  };

  const userDetails = Cookies.get("user_details");

  return userDetails ? (
    <Navigate to="/configuration" replace />
  ) : (
    <>
      {contextHolder}
      <section
        style={{
          ...styles.section,
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
        }}
      >
        <div style={styles.container}>
          {/* HEADER */}
          <div style={styles.header}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
                alt="Logo"
                style={{
                  width: "5rem",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
              />
              <h2>Step to Innovation</h2>
            </div>
            <p style={styles.subtitle}>
              Enter the 6-digit OTP sent to your email
            </p>
          </div>

          <Form onFinish={onFinish} layout="vertical">
            <Form.Item>
              <div style={styles.otpContainer} onPaste={handlePaste}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={digit}
                    style={styles.otpBox}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onFocus={(e) => e.target.select()}
                  />
                ))}
              </div>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                block
                type="primary"
                htmlType="submit"
                style={styles.button}
                disabled={isLoading}
                icon={
                  isLoading ? (
                    <Spin
                      indicator={<SyncOutlined spin />}
                      style={{ color: "white" }}
                    />
                  ) : null
                }
              >
                {!isLoading && "Verify OTP"}
              </Button>
            </Form.Item>

            <Flex justify="space-between" style={{ marginTop: "16px" }}>
              <Link to="/login" style={styles.link}>
                Back to Login
              </Link>
              <Link to="/forget-password" style={styles.link}>
                Forgot password?
              </Link>
            </Flex>
          </Form>
        </div>
      </section>
    </>
  );
}
